import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandProfile } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = BrandProfile

export const fetchBrandProfile = async ({
  id,
  workspaceId,
  signal,
}: {
  id: number
  workspaceId: number
  signal?: AbortSignal
}) => {
  const res = await sendToApi<{ brand_profile: BrandProfile }>(`/w/${workspaceId}/brand_profiles/${id}`, { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.brand_profile
}

export const useBrandProfile = (id: number, options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(
    ['workspaces', workspaceId, 'brandProfiles', 'detail', id],
    () => fetchBrandProfile({ id, workspaceId }),
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
